<template>
  <span class="relative inline-block size-2 shrink-0" role="img" :aria-label="label">
    <span
      v-if="on"
      class="absolute inset-0 animate-[rmPulse_2.4s_ease-out_infinite] rounded-full bg-positive motion-reduce:hidden" />
    <span class="absolute inset-0 rounded-full" :class="on ? 'bg-positive' : 'bg-line-strong'" />
  </span>
</template>

<script setup lang="ts">
defineProps<{ on: boolean; label?: string }>()
</script>

<style>
@keyframes rmPulse {
  0% {
    transform: scale(1);
    opacity: 0.55;
  }
  70%,
  100% {
    transform: scale(2.6);
    opacity: 0;
  }
}
</style>
